.row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px var(--gutter);
}

.main {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 12px;
}

.text {
  display: flex;
  flex-direction: column;
  min-width: 0;
  gap: 2px;
}

.name {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-weight: 700;
  font-size: var(--fs-md);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sub {
  font-size: var(--fs-sm);
  color: var(--text-3);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.card {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  width: 140px;
  padding: 16px 12px 14px;
  border-radius: var(--r-lg);
  background: var(--surface-1);
  border: 1px solid var(--border);
  text-align: center;
}

.cardLink {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  max-width: 100%;
}

.card .name {
  font-size: var(--fs-sm);
  max-width: 116px;
  margin-top: 6px;
}

.card .sub {
  font-size: var(--fs-xs);
}
